import React, { Component } from "react";
import DashboardPopularHostCardComponent from "./DashboardPopularHostCardComponent";
import loadinggif from "../../../assets/images/loading.gif";
import { withTranslation } from "react-i18next";

class PopularHostsViewAllComponent extends Component {
  componentDidMount() {
    const {
      fetchPopularBrandsViewAllIfNeeded,
      invalidateAllPopularBrandsViewAll
    } = this.props;
    invalidateAllPopularBrandsViewAll();
    fetchPopularBrandsViewAllIfNeeded({
      page: 1
    });
  }
  componentDidUpdate() {
    document.body.classList.remove("modal-open");
  }

  render() {
    let { page , t } = this.props;
    return (
      <section className="container-fluid my-tournament-wrapper">
        <div className="row">
          <div className="container">
            <div className="padder-main">
              <div className="row d-flex align-items-center mb-30 ">
                <div className="col-8 d-flex justify-content-start">
                  <h2 className="bold">{t("popularHost")}</h2>
                </div>
              </div>

              <div className="row card-wrapper d-flex justify-content-center justify-content-sm-start">
                {this.props.popularBrandsViewAll.items.length > 0
                  ? this.props.popularBrandsViewAll.items.map(
                      (tournament, i) => (
                        <div className="col-auto mb-4" key={i}>
                          <DashboardPopularHostCardComponent
                            {...tournament}
                            key={i}
                            order={i + 1}
                          />
                        </div>
                      )
                    )
                  : ""}
              </div>
              <div className="row mb-30 text-center">
                <div className="col-sm-12">
                  {this.props.popularBrandsViewAll.items.length > 0 ? (
                    !this.props.popularBrandsViewAll.isLastPage ? (
                      <button
                        onClick={() => {
                          this.props.invalidatePopularBrandsViewAll();
                          this.props.fetchPopularBrandsViewAllIfNeeded({
                            page: page
                          });
                        }}
                        className="btn btn-pink dark btn-xs"
                      >
                        {t("loadMore")}
                      </button>
                    ) : this.props.popularBrandsViewAll.isFetching ? (
                      <img src={loadinggif} alt="" />
                    ) : (
                      ""
                    )
                  ) : this.props.popularBrandsViewAll.isFetching ? (
                    <img className="text-center" src={loadinggif} alt="" />
                  ) : (
                    <span>{t("noHostsFound")}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withTranslation()(PopularHostsViewAllComponent);
